import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.6474 2.83406V5.77286C8.28904 5.82683 6.40658 6.56704 5.04623 7.97476C2.65047 10.4542 2.7463 14.0859 2.7518 14.239L3.31467 14.25C3.33119 14.0451 3.7751 9.28224 10.6474 9.15556V12.0889L16.7541 7.46146L10.6474 2.83406Z",
		fill: "currentColor"
	})
});
export default SvgSendArrow;
